import { render, staticRenderFns } from "./successQuit.vue?vue&type=template&id=4860d448&scoped=true&"
import script from "./successQuit.vue?vue&type=script&lang=js&"
export * from "./successQuit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860d448",
  null
  
)

export default component.exports